/**
 *  17/01/2019 v 1.0 - JuanMa
 *  v1.1 27/03/2019 En filtrarNombreCampo, añadida bifurcacion si es String, para solo hacer toUpper en ese caso.
 *  v1.2 24/10/2019 Añadida función filtrarConTodosCampos
 *  v1.3 30/10/2019 Añadida función contieneElementoConNomberCampo
 *                  Añadida funcion getPosElementoConNombreCampo
 *  v1.4 24/03/2019 Modificada la función filtrarConNombreCampo, para tener en cuenta si el filtro es un objeto.
 *  v1.5 04/05/2020 Añadida comprobación de datos existentes en la función filtrarConNombreCampo
 *  v2.0 05/10/2020 Añadida función filtrarConNombreCampoElemento
 *
 *
 *  v2.1 02/07/2021 Modificada la funcion filtrarConTodosCampos pasando de === a valorActual == filtro para el tema de comparar numeros de codigos con cadenas de codigos.
 *  v2.2 18/03/2022 Añadida función filtrarConCamposGridConfigColumnas
 *
 *  v2.3 06/05/2022 Fusion planifikator y Sidemur
 *  v2.4 26/07/2022 Modificado filtrarConCamposGridConfigColumnas para soportar OR de positivos y AND de negativos
 *
 *  v2.5 24/10/2024 En filtrarConNombreCampo, modificada la comparacion de tipos a "if (typeof valorActual === 'string' && typeof valorBuscado === 'string'"
 *
 *  v2.6 08/01/2025 Creada nueva función filtrarConTodosCampos que entra en las propiedades que son objetos.
 *                  Creada nueva funcion objetoContieneValorEnCampo.
 *                  Creada nueva función buscarConNombreCampo.
 **/

import {getValor} from "../../adazzle/Formatters";

export const filtrarConIndiceCampo= (datos, indiceCampo, valor) => {
    if (datos.length > 0) {
        let nombreCampo=  Object.keys(datos[0])[indiceCampo];
        return filtrarConNombreCampo(datos, nombreCampo, valor);
    }
}

export const filtrarConNombreCampo= (datos, nombreCampo, filtro) => {
    /*
    console.log("**filtrarConNombreCampo");
    console.log("datos:");
    console.log(datos);
    console.log("nombreCampo: " + nombreCampo);
    console.log("filtro:");
    console.log(filtro);
    */
    if (!datos)
        return null;

    let valorBuscado= filtro;
    if (typeof filtro === 'object' && filtro !== null)
        valorBuscado= filtro[nombreCampo];

    let newDatos = datos.reduce((newDatosReduced, dato) => {
        let valorActual= dato[nombreCampo];
        //Cuando es cadena pasamos a mayusculas
        if (typeof valorActual === 'string' && typeof valorBuscado === 'string') {
            //console.log("valorActual: ", valorActual);
            //console.log("typeof valorActual: ", typeof valorActual);
            if (valorActual.toUpperCase().includes(valorBuscado.toUpperCase()))
                newDatosReduced.push(dato);
        }
        else{
            if (valorActual === valorBuscado)
                newDatosReduced.push(dato);
        }
        return newDatosReduced;
    }, []);
    return newDatos;
}

export const buscarConNombreCampo= (datos, nombreCampo, filtro) => {


    /*
    console.log("************filtrarConNombreCampo");
    console.log("datos:");
    console.log(datos);
    console.log("nombreCampo: " + nombreCampo);
    console.log("filtro:");
    console.log(filtro);
    */

    if (!datos)
        return null;

    let valorBuscado= filtro;
    if (typeof filtro === 'object' && filtro !== null)
        valorBuscado= filtro[nombreCampo];

    let elementoBuscado= null;
    datos.forEach((dato, index) => {
        let valorActual= dato[nombreCampo];
        //Cuando es cadena pasamos a mayusculas
        if (typeof valorActual === 'string') {
            if (valorActual.toUpperCase() == valorBuscado.toUpperCase())
                elementoBuscado= dato;
        }
        else{
            if (valorActual === valorBuscado)
                elementoBuscado= dato;
        }
    });

    return elementoBuscado;

}

export const filtrarConNombreCampoElemento= (datos, nombreCampo, filtro) => {
    let coincidentes = filtrarConNombreCampo(datos, nombreCampo, filtro);
    if (coincidentes && coincidentes.length > 0) {
        return coincidentes[0];
    }
    return null;
}

export const contieneElementoConNombreCampo= (datos, nombreCampo, valorBuscado) => {
    let encontrado= false;
    datos.forEach( (dato) => {
        if (!encontrado) {
            let valorActual = dato[nombreCampo];
            //Cuando es cadena pasamos a mayusculas
            if (typeof valorActual === 'string') {
                if (valorActual.toUpperCase() === valorBuscado.toUpperCase())
                    encontrado= true;
            } else {
                if (valorActual === valorBuscado)
                    encontrado= true;
            }
        }
    });
    return encontrado;
}

export const getPosElementoConNombreCampo= (datos, nombreCampo, valorBuscado) => {
    let pos= -1;
    let posActual= 0;
    datos.forEach( (dato) => {
        if (pos < 0) {
            let valorActual = dato[nombreCampo];
            //Cuando es cadena pasamos a mayusculas
            if (typeof valorActual === 'string') {
                if (valorActual.toUpperCase() === valorBuscado.toUpperCase())
                    pos= posActual;
            } else {
                if (valorActual === valorBuscado)
                    pos= posActual;
            }
            posActual++;
        }
    });
    return pos;
}

export const filtrarConTodosCamposOld= (datos, filtro) => {
    let newDatos = datos.reduce((newDatosReduced, dato) => {
        //Recorremos todas las propiedades
        let encontrado= false;
        for (const prop in dato) {
            if (!encontrado) {
                let valorActual = dato[prop];
                //Cuando es cadena pasamos a mayusculas
                if (typeof valorActual === 'string') {
                    if (valorActual.toUpperCase().includes(filtro.toUpperCase())) {
                        newDatosReduced.push(dato);
                        encontrado = true;
                    }
                } else {
                    if (valorActual == filtro) {
                        newDatosReduced.push(dato);
                        encontrado = true;
                    }
                }
            }
        }
        return newDatosReduced;
    }, []);
    return newDatos;
}

//Entra en los objetos
export const filtrarConTodosCampos= (datos, filtro) => {
    let newDatos = datos.reduce((newDatosReduced, dato) => {
        let datoAceptado= objetoContieneValorEnCampo(dato, filtro, 0);
        if (datoAceptado)
            newDatosReduced.push(dato);
        return newDatosReduced;
    }, []);
    return newDatos;

}

export const objetoContieneValorEnCampo= (dato, filtro, nivel) => {
    let datoAceptado= false;
    //Recorremos los campos
    for (var i=0; i < Object.keys(dato).length; i++){
        let nombreCampo= Object.keys(dato)[i];
        let valorCampo = dato[nombreCampo];

        if (typeof valorCampo === 'string') {
            if (valorCampo.toUpperCase().includes(filtro.toUpperCase())) {
                datoAceptado = true;
            }
        } else {
            if (typeof valorCampo === 'object') {
                if (!nivel || nivel <= 1) {
                    let datoAceptadoInferior = objetoContieneValorEnCampo(valorCampo, filtro, 1);
                    if (datoAceptadoInferior === true)
                        datoAceptado= true;
                }

            } else {
                if (valorCampo === filtro) {
                    datoAceptado = true;
                }
            }
        }
        console.log(nombreCampo, " = ", valorCampo, " -> ", typeof valorCampo, " === ", datoAceptado);
    }
    console.log("+++++++++++++++++ datoAceptado: ", datoAceptado);
    return datoAceptado;
}


export const filtrarConFiltro= (datos, filtro) => {
    let newDatos = datos.reduce((newDatosReduced, dato) => {
        let datoAceptado= true;
        //Recorremos los campos del filtro y aplicamos los que tengan valor
        for (var i=0; i < Object.keys(filtro).length; i++){
            let filtroNombreCampo= Object.keys(filtro)[i];
            if (datoAceptado) {
                let filtroValorCampo = filtro[filtroNombreCampo];
                if (filtroValorCampo) {
                    let datoValorCampo = dato[filtroNombreCampo];
                    datoAceptado = datoValorCampo.toUpperCase().includes(filtroValorCampo.toUpperCase());
                }
            }
        }
        /*
        Object.keys(filtro).map( (filtroNombreCampo) => {
            if (datoAceptado) {
                let filtroValorCampo = filtro[filtroNombreCampo];
                if (filtroValorCampo) {
                    let datoValorCampo = dato[filtroNombreCampo];
                    datoAceptado = datoValorCampo.toUpperCase().includes(filtroValorCampo.toUpperCase());
                }
            }
            return ""
        });
        */
        if (datoAceptado)
            newDatosReduced.push(dato);
        return newDatosReduced;
    }, []);
    return newDatos;
}

export const filtrarConCamposGridConfigColumnasOld= (datos, filtro, gridConfigColumnas ) => {
    let newDatos = datos.reduce((newDatosReduced, dato) => {
        //Recorremos todas las columnas
        let encontrado= false;
        gridConfigColumnas.forEach ((columna, index) => {
            if (!encontrado) {
                let valorActual = getValor(columna.campo, dato, null);
                //Cuando es cadena pasamos a mayusculas
                if (typeof valorActual === 'string') {
                    if (valorActual.toUpperCase().includes(filtro.toUpperCase())) {
                        newDatosReduced.push(dato);
                        encontrado = true;
                    }
                } else {
                    if (valorActual === filtro) {
                        newDatosReduced.push(dato);
                        encontrado = true;
                    }
                }
            }
        });
        return newDatosReduced;
    }, []);
    return newDatos;
}


//Deja los elementos que cumplen una de las condiciones positivas y elimina de ellos los que cumplen las negativas
export const filtrarConCamposGridConfigColumnas= (datos, filtroOrigen, gridConfigColumnas ) => {
    let filtros= filtroOrigen.split(" ");
    //console.log("*** filtrarConCamposGridConfigColumnas ***");
    //console.log("filtro: ", filtroOrigen);
    //console.log("filtros: ", filtros);

    //1. Clasificamos los filtros
    let filtrosPositivos= [];
    let filtrosNegativos= [];
    filtros.forEach((filtroActual) => {
        if (filtroActual != "" && filtroActual != "!") {
            if (filtroActual.startsWith('!'))
                filtrosNegativos.push(filtroActual.trim().slice(1)); //Quitamos el primer caracter (el !)
            else
                filtrosPositivos.push(filtroActual.trim());
        }
    });


    let newDatos = datos.reduce((newDatosReduced, dato) => {
        //Recorremos todas las columnas
        //console.log("*" , dato.codigoId, " ", dato.proyectoNombre);

        //1. Hacemos un AND con las condiciones positivas:
        let encontrado= true; //Si no hay condicion positiva, todos los datos entran
        if (filtrosPositivos.length > 0) {
            let todosfiltrosencontrados= true;

            filtrosPositivos.forEach((filtro, index) => {
                if (todosfiltrosencontrados) {
                    //console.log("filtro: ", filtro);
                    let filtroEncontrado = false;
                    gridConfigColumnas.forEach((columna, index) => {
                        if (!filtroEncontrado && filtro != "" && filtro != "!") {
                            let valorActual = getValor(columna.campo, dato, null);
                            //Cuando es cadena pasamos a mayusculas
                            if (!filtro.startsWith('!')) {
                                if (typeof valorActual === 'string') {
                                    if (valorActual.toUpperCase().includes(filtro.toUpperCase()))
                                        filtroEncontrado = true;
                                } else {
                                    if (valorActual === filtro)
                                        filtroEncontrado = true;
                                }
                            }
                        }
                    });
                    //console.log("filtroEncontrado: ", filtroEncontrado);
                    todosfiltrosencontrados = filtroEncontrado;
                }
            });

            //console.log("*" , dato.codigoId, " ", dato.proyectoNombre, " -> ", todosfiltrosencontrados);
            encontrado= todosfiltrosencontrados;

        }

        //Si es un elemento "encontrado", vemos si cumple alguna condicion negativa para quitarlos
        let eliminado= false;
        if (encontrado && filtrosNegativos.length > 0) {
            console.log("FILTRADO NEGATIVO");
            gridConfigColumnas.forEach ((columna, index) => {
                if (!eliminado) {
                    let valorActual = getValor(columna.campo, dato, null);
                    console.log("valorActual: ", valorActual);
                    filtrosNegativos.forEach((filtro, index) => {
                        console.log("filtro: ", filtro);
                        if (!eliminado){
                            //Cuando es cadena pasamos a mayusculas
                            if (typeof valorActual === 'string') {
                                if (valorActual.toUpperCase().includes(filtro.toUpperCase())) {
                                    eliminado = true;
                                    console.log("Eliminado");
                                }
                            } else {
                                if (valorActual === filtro)
                                    eliminado= true;
                            }
                        }
                    });

                }
            });
        }

        if (encontrado && !eliminado)
            newDatosReduced.push(dato);

        return newDatosReduced;
        }, []);
    return newDatos;
}

export const eliminarElemento= (datos, nombreCampo, valorCampo) => {
let newDatos = datos.reduce((newDatosReduced, dato) => {
if (dato[nombreCampo] !== valorCampo)
    newDatosReduced.push(dato);
return newDatosReduced;
}, []);
return newDatos;

}

export const inArrayInt= (datos, valorBuscado) => {
for (var i = 0; i < datos.length; i++) {
if (datos[i] === valorBuscado)
    return true;
}
return false;
}